import './blog.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import { useHistory} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {BLOGS_TYPE} from "../../constants/constType";
import {GetBlog, GetBlogCount} from "../../redux/actions";
import { PageLeftArrIcon, PageRightArrIcon} from "../../assets/images";
import BlogCard from "../../components/uiElements/cards/blogCard/BlogCard";
import {Pagination} from "antd";
import {PAGE_NEWS_COUNT} from "../../constants/constType";
import React from "react";

function Blog(props){
    const {blog,blogCount,staticTexts} = props
    const [currentPage, setCurrentPage] = useState(1);
    const [type, setType] = useState('');
    const history = useHistory()
    const isFetching = useRef(false)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },[])

    useEffect(() => {
        Object.keys(BLOGS_TYPE).map(item => {
            if(history.location.pathname.includes(item)){
                setType(BLOGS_TYPE[item])
                setCurrentPage(1)
                props.GetBlog({type:BLOGS_TYPE[item], limit:PAGE_NEWS_COUNT})
                props.GetBlogCount({type:BLOGS_TYPE[item]})
            }
        })
    },[history.location.pathname])

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a className={'prev_btn'}>
                <PageLeftArrIcon/>
            </a>;
        }
        if (type === 'next') {
            return <a className={'next_btn'}>
                <PageRightArrIcon/>
            </a>;
        }
        return originalElement;
    };

    async function onChangePaging (page) {
        isFetching.current = true;
        const configInfo = {
            reset: true,
            offset: (page -1) * PAGE_NEWS_COUNT,
            limit: PAGE_NEWS_COUNT,
            type,
        }
        await props.GetBlog(configInfo)
        setCurrentPage(page);
        window.scrollTo({
            top: 0
        });
    }

    return <div className={'blogs-wrapper'}>
        {
            blog?.length > 0 ? <div className={'blogs_content'}>
                <div className={'blogs-header'}>
                    <div className={'blog-title'}>
                        {staticTexts[`blog_title_${type}`]}
                    </div>
                    <div className={'blog-description'}>
                        {staticTexts[`blog_description_${type}`]}
                    </div>
                </div>
                {
                    blog?.length > 0 ?  <div className={'blogs-block'}>
                        {/*<Link to={`/news/${blog[0]?.slug}`} className={'blogs-top-card'}>*/}
                        {/*    <div className={'blogs-top-img-wrapper'}>*/}
                        {/*        <div className={'blogs-top-card-type'}>*/}
                        {/*            {blog[0]?.type}*/}
                        {/*        </div>*/}
                        {/*        <div className={'blogs-top-card-img'}>*/}
                        {/*            <img src={generateImageMediaUrl(blog[0]?.mediaMain?.path)} alt=""/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*    <div className={'blogs-top-card-info'}>*/}
                        {/*        <div className={'blogs-top-card-title'}>*/}
                        {/*            <span>{blog[0]?.title}</span>*/}
                        {/*        </div>*/}
                        {/*        <div className={'blogs-top-card-date'}>*/}
                        {/*            {moment(blog[0]?.date).format('ll')}*/}
                        {/*        </div>*/}
                        {/*        <div className={'blogs-top-card-description'} dangerouslySetInnerHTML={{__html: blog[0]?.description}}/>*/}
                        {/*        <div className={'arr-wrapper'}>*/}
                        {/*            <NewsArrIcon/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</Link>*/}
                        {
                            blog?.map((item) => {
                                return <div className={'blogs-card'} key={blog?.id}>
                                    <BlogCard item={item}/>
                                </div>
                            })
                        }
                    </div> : ''
                }
                {blog?.length > 0 ? <Pagination current={currentPage}
                                                defaultPageSize={12}
                                                onChange={onChangePaging}
                                                itemRender={itemRender}
                                                hideOnSinglePage={true}
                                                className={`pagination-product`}
                                                total={blogCount || 0}/> : ''}
            </div> : ''
        }
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'languages',
        'blog',
        'blogCount',
    ])
};
const mapDispatchToProps = {
    GetBlog,
    GetBlogCount
};
export default connect(mapStateToProps,mapDispatchToProps)(Blog);
